import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Nawigacja',
    links: [
      { label: 'Strona główna', href: '/' },
      { label: 'Kategorie produktów', href: '/#categories' },
      { label: 'Poradniki', href: '/#guides' },
      { label: 'Bezpieczeństwo', href: '/#safety' },
      { label: 'FAQ', href: '/#faq' },
    ],
  },
  {
    title: 'Kategorie',
    links: [
      { label: 'Sneakersy', href: 'https://kaspreadsheet.com/category-911-Shoes.html' },
      { label: 'Bluzy', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
      { label: 'Kurtki', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
      { label: 'Torby', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
      { label: 'Akcesoria', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
    ],
  },
  {
    title: 'Poradniki',
    links: [
      { label: 'Kompletny przewodnik', href: '/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik' },
      { label: 'Sneakersy', href: '/artykul/kakobuy-sneakers-spreadsheet' },
      { label: 'Wysyłka do Polski', href: '/artykul/kakobuy-shipping-polska' },
      { label: 'Bezpieczeństwo', href: '/artykul/kakobuy-bezpieczenstwo' },
      { label: 'Dla początkujących', href: '/artykul/kakobuy-jak-zaczac' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-store-2-line text-xl text-white"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-white whitespace-nowrap">
                Kakobuy <span className="text-accent-300">Polska</span>
              </span>
            </Link>
            <p className="text-sm text-white/70 leading-relaxed">
              Najlepsze źródło informacji o Kakobuy Spreadsheet w Polsce. Odkrywaj produkty, porównuj ceny i kupuj bezpiecznie.
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-semibold text-sm mb-4 text-white">{group.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) =>
                  link.href.startsWith('http') ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-white/60 hover:text-white transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-white/60 hover:text-white transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/50">
            &copy; 2026 Kakobuy Polska. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-sm text-white/50 hover:text-white transition-colors duration-200">
              Polityka prywatności
            </Link>
            <Link to="/" className="text-sm text-white/50 hover:text-white transition-colors duration-200">
              Regulamin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}